import { api } from "./api";

export const lnsService = {
  // Get all LNS (LoRaWAN Network Servers)
  getLnss: () => api.get("/lns").then((res) => res.data),

  // Get LNS by ID
  getLns: (id) => api.get(`/lns/${id}`).then((res) => res.data),

  // Create LNS
  createLns: (lnsData) => api.post("/lns", lnsData),

  // Update LNS
  updateLns: (id, lnsData) => api.put(`/lns/${id}`, lnsData),

  // Delete LNS
  deleteLns: (id) => api.delete(`/lns/${id}`),
};
